<template>
  <div id="avg-consumption" class="avg-consumption">
    <div class="body">
      <highcharts :options="options"></highcharts>
    </div>
  </div>
</template>

<script>

import requests from '../../requests';

  export default {
    name:'avg-consumption',
    props: {
      data: Object
    },
    data() {
      return {
        options: {
        chart: {
          type: 'bar',
          height:180
        },
        title: {
            text: null
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: true,
          verticalAlign: 'top'
        },
        xAxis:{
          categories:['Average comsumption'],
          labels:{
            enabled:false
          }
        },
        yAxis: {
          title:{
            text:'Average Consumption',
            algin:'high'
          },
          max:100
        },
        tooltip: {
          enabled: true,
           valueDecimals: 2
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: false
            }
          },
          series: {
            minPointLength: 2
          }
        },
        series: []
      }

      }
    },
    beforeMount() {
    },
    watch: {
      data(newData) {
        if (newData) {
          this.options.series = newData.map(v=> Object.assign({}, {data: v.data}, {name:v.name}))
        }
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// AvgConsumption.vue?19ddfae9